import { ExpenseReport } from "../models/expense_report";

export const downloadCSV = (reports: ExpenseReport[], exportName: string) => {
  const headers = [
    'Date', 
    'Collaborateur', 
    'Catégorie', 
    'Fournisseur', 
    'Description', 
    'Montant HT', 
    'TVA', 
    'Montant TTC', 
    'Statut'
  ];

  const csvRows = reports.map(r => {
    const date = r.expense_date ? new Date(r.expense_date).toLocaleDateString("fr-FR") : "";
    
    const userFirstName = r.user?.first_name || "";
    const userLastName = r.user?.last_name || "";
    const actualEmployee = `${userFirstName} ${userLastName}`.trim() || exportName;

    const category = r.category?.item_type || "";
    const supplier = r.supplier_name || "";
    
    const description = (r.comment || "").replace(/"/g, '""').replace(/\n/g, ' '); 
    
    const amountTTC = Number(r.amount) || 0;
    const vatAmount = Number(r.vat_amount) || 0;
    const amountHT = amountTTC - vatAmount;
    
    const status = r.status || "";

    return [
      `"${date}"`,
      `"${actualEmployee}"`, 
      `"${category}"`,
      `"${supplier}"`,
      `"${description}"`,
      amountHT.toFixed(2),
      vatAmount.toFixed(2),
      amountTTC.toFixed(2),
      `"${status}"`
    ].join(','); 
  });

  const csvString = [headers.join(','), ...csvRows].join('\n');
  
  const blob = new Blob(['\uFEFF' + csvString], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  const filename = `export_${exportName.replace(/\s+/g, '_')}_${new Date().getTime()}.csv`;
  link.setAttribute('download', filename);
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};